import { Fancybox, Panzoom } from '@fancyapps/ui';


//import '@fancyapps/ui/dist/fancybox.css';
window.Fancybox = Fancybox; // ← Exposes it to console
import "@fancyapps/ui/dist/fancybox/fancybox.css";
const $ = window.jQuery;

const FancyInit = {
	init() {
		const $module = $('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"], a[href*=".webp"]');

		if (!$module.length) {
			return;
		}

		if ($module.closest('.wp-block-gallery')[0]) {
			$module.closest('.wp-block-gallery').find('a').attr('data-fancybox', 'galleri');
		} else {
			$module.attr('data-fancybox', 'galleri');
		}

		$module
			.parent()
			.find('figcaption')
			.each(function () {
				$(this).closest('figure').find(`a`).attr('data-caption', $(this).text());
			});

		Fancybox.bind('[data-fancybox]', {
			// Do not hide page scrollbars
			hideScrollbar: false,

			// Disable drag to close guesture
			dragToClose: false,

			// Hide close button
			closeButton: true,

			// Disable toolbar
			Toolbar: true,

			// Disable zoom animation; close on click and wheel events
			Image: {
				zoom: false,
				click: 'toggleZoom',
				wheel: 'toggleZoom',
				Panzoom: {
					smooth: 1,
					zoomSpeed: 0.1,
					zoomStep: 0.1,
					maxScale: () => 8,
				},
			},
			Images: {
				zoom: true,
				click: 'toggleZoom',
				wheel: 'toggleZoom',
				Panzoom: {
					maxScale: () => 2,
				},
			},

			// Custom animations
			showClass: 'fancybox-zoomIn',
			hideClass: 'fancybox-zoomOut',
			on: {
				initCarousel: (fancybox) => {
					const slide = fancybox.Carousel?.slides?.[fancybox.Carousel?.page];
					if (!slide || !fancybox.$container || !slide.$thumb) return;
			
					fancybox.$container.style.setProperty('--bg-image', `url("${slide.$thumb.src}")`);
				},
				'Carousel.change': (fancybox, carousel, to, from) => {
					const slide = carousel.slides[to];
					if (!slide || !fancybox.$container || !slide.$thumb) return;
			
					fancybox.$container.style.setProperty('--bg-image', `url("${slide.$thumb.src}")`);
				},
			},
		});
	},
};

export default FancyInit;
